import { useCurrentDocument, useDocumentBlockData } from '../../hooks/useDocument';

import { DataContextProvider } from '../../contexts/DataContext';
import Blocks from './Blocks';

interface DataProviderBlockProps {
    id: string;
    blocks: Block[];
    className?: string;
}

function DataProviderBlock({ id = null, blocks, className }: DataProviderBlockProps) {
    const currentDocument = useCurrentDocument();
    const { id: documentId = null } = currentDocument || {};
    const { data, isLoading = false } = useDocumentBlockData(documentId, id);
    return (
        <DataContextProvider data={data} isLoading={isLoading}>
            <Blocks blocks={blocks} className={className} />
        </DataContextProvider>
    );
}

export default DataProviderBlock;
